import { render, staticRenderFns } from "./ListIdeaCard.vue?vue&type=template&id=1bacae54&"
import script from "./ListIdeaCard.vue?vue&type=script&lang=js&"
export * from "./ListIdeaCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports